import { render, staticRenderFns } from "./MaterialMapping.vue?vue&type=template&id=5feec9b4&scoped=true"
import script from "./MaterialMapping.vue?vue&type=script&lang=js"
export * from "./MaterialMapping.vue?vue&type=script&lang=js"
import style0 from "./MaterialMapping.vue?vue&type=style&index=0&id=5feec9b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feec9b4",
  null
  
)

export default component.exports